'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = require('react-side-effect');

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BodyStyle = function (_Component) {
  (0, _inherits3.default)(BodyStyle, _Component);

  function BodyStyle() {
    (0, _classCallCheck3.default)(this, BodyStyle);
    return (0, _possibleConstructorReturn3.default)(this, (BodyStyle.__proto__ || (0, _getPrototypeOf2.default)(BodyStyle)).apply(this, arguments));
  }

  (0, _createClass3.default)(BodyStyle, [{
    key: 'render',
    value: function render() {
      return this.props.children ? _react.Children.only(this.props.children) : null;
    }
  }]);
  return BodyStyle;
}(_react.Component); // Taken from https://github.com/studiofrenetic/body-style/. Code works fine but npm package is not compatible with React >0.14.

BodyStyle.propTypes = {
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string
};

function reducePropsToState(propsList) {
  var style = {};
  var className = '';

  propsList.forEach(function (prop) {
    (0, _assign2.default)(style, prop.style);

    if (prop.className) {
      className = prop.className;
    }
  });
  return { style: style, className: className };
}

function handleStateChangeOnClient(_ref) {
  var style = _ref.style,
      className = _ref.className;

  for (var key in style) {
    if (document.body.style.hasOwnProperty(key)) {
      document.body.style[key] = style[key];
    }
  }

  document.body.className = className;
}

exports.default = (0, _reactSideEffect2.default)(reducePropsToState, handleStateChangeOnClient)(BodyStyle);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/BodyStyle.js
// module id = 2188
// module chunks = 0